module.exports = __webpack_public_path__ + "static/media/group--fire.65e7b76b.svg";